import axios from 'axios';

import { env } from 'config';
import { MerchantGroup } from 'types';

import { createCrudApi } from './crud.api';

const url = `${env.apiUrl}/merchant-groups`;

export type MerchantGroupPayload = {
  name: string;
  shopIds: string[];
  operatorIds?: string[];
  payin: boolean;
  payout: boolean;
};

const crudApi = createCrudApi<MerchantGroup>('/merchant-groups');

export const merchantGroupsApi = {
  getAll: crudApi.getAll,
  getOne: crudApi.getOne,
  remove: crudApi.remove,
  create: async (data: MerchantGroupPayload): Promise<MerchantGroup> =>
    (await axios.post(url, data)).data,
  update: async ({
    id,
    data,
  }: {
    id: string;
    data: Partial<MerchantGroupPayload>;
  }): Promise<MerchantGroup> => (await axios.patch(`${url}/${id}`, data)).data,
};
